import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { SecureStorageService } from './secure-storage.service';
import { AuthService } from './auth.service';

@Injectable()
export class AuthInterceptorClass implements HttpInterceptor {
  constructor(private secureStorage: SecureStorageService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const token = this.secureStorage.getItem<string>('token');
    
    if (token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }
    
    return next.handle(request);
  }
}

export const AuthInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const secureStorage = inject(SecureStorageService);
  const authService = inject(AuthService);
  let token = secureStorage.getItem<string>('token');

  if (token) {
    try {
      token = JSON.parse(token);
    } catch {
      token = token.replace(/"/g, '');
    }
  }

  // Ne pas utiliser '/' ici : toute URL contient un slash et excluait l’ajout du JWT sur les appels API.
  const publicRoutes = ['explore', 'sendmail-info', 'celebrities/domaines', 'verify-email'];
  const requestUrl = req.url.toLowerCase();

  if (publicRoutes.some(route => requestUrl.includes(route))) {
    return next(req);
  }

  if (token) {
    const isFormData = req.body instanceof FormData;
    req = req.clone({
      setHeaders: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
        ...(isFormData ? {} : { 'Content-Type': 'application/json' })
      }
    });
  }

  return next(req).pipe(
    tap({
      error: (error: HttpErrorResponse) => {
        if (error.status === 401) {
          console.warn('⛔ Token expiré ou invalide, redirection vers login...');
          // Nettoyage complet de session + redirection (cohérent avec logout())
          authService.clearSessionAndRedirect();
        }
      }
    })
  );
};

